import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "items-center rounded-full border w-fit px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        yellow:
          "border-transparent bg-yellow-500 text-black font-thin hover:bg-yellow-500/80",
        sky: "border-transparent bg-sky-500 text-primary-foreground font-thin hover:bg-sky-500/80",
        success:
          "border-transparent bg-green-500 text-white hover:bg-green-500/80",
        info:
          "border-transparent bg-blue-500 text-white hover:bg-blue-500/80",
        warning:
          "border-transparent bg-orange-500 text-white hover:bg-orange-500/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
  VariantProps<typeof badgeVariants> {
  customClass?: string; // New prop for additional class names
  style?: React.CSSProperties; // New prop for inline styles
}

function Badge({ className, variant, customClass, style, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant }), className, customClass)}
      style={style}
      {...props}
    />
  );
}

export { Badge, badgeVariants };